import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm, FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { EnvService } from 'app/env.service';
import { userTypes } from 'app/shared/enum/userTypes.enum';
// import { AuthService } from 'app/shared/auth/auth.service';
import { HelperService } from 'app/shared/services/helper.service';
import { AuthUserService } from 'app/shared/services/userServices/auth-user.service';
import { StorageService } from 'app/shared/services/userServices/storage.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from "ngx-spinner";



@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})

export class LoginPageComponent implements OnInit {

  loginFormSubmitted = false;
  isLoginFailed = false;
  userTypes = userTypes
  loginForm = new FormGroup({
    email: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
    userType:new FormControl( localStorage.getItem('type') ? +localStorage.getItem('type'): +this.userTypes.Admin),
    rememberMe: new FormControl(true)
  });
  showPasswordText = false;
  type = userTypes.Admin
  constructor(
    private router: Router,
    private helperService: HelperService,
    private authService: AuthUserService,
    private route: ActivatedRoute,
    private storage: StorageService,
    private envService: EnvService,
    ) {
  }

  ngOnInit(): void {

 

 this.route.queryParams.subscribe(async params => {
        

  if (this.authService.isUserAuthenticated()) {
    if(this.authService.isUserAdmin())
    {
    this.router.navigateByUrl(this.authService.getAdminFirstLandPage());
    }
    else if(this.authService.isUserStudent())
    {
       this.router.navigateByUrl('/student/student-dashboard');
    }


  }else{

    const key1 = params['key1'] || "0";
    const key2 = params['key2'] || "0";
    const key3 = params['key3'] || "0";

    if(key1 != "0" && key2 != "0" && key3 != "0" )
    {  
        //let x = "Alvsyp_I6Uc7htvpthWMWg,,";
        await this.onSubmitSSO(key1 ,key2) 
     }
    else
    {
      var redirecturl=this.envService.Website_URL+"/#/pages/login";
       var falidurl  =this.envService.Website_URL+"/#/pages/login";
       window.location.href = `https://ssobasic.nbu.edu.sa/api/Login/WebEn?redirectURL=${encodeURIComponent(redirecturl)}&failUrl=${encodeURIComponent(falidurl)}`;
    
    }
    
  }



  


 
  
})

    



  
  }

  setType(userType){
    this.type = userType;
    this.loginForm.reset()
    this.loginForm.get('userType').setValue(+userType);
  }

  showPassword() {
    this.showPasswordText = !this.showPasswordText;
  }

  get lf() {
    return this.loginForm.controls;
  }

  // On submit button click
  async onSubmit() {
    try {
      this.loginFormSubmitted = true;
      if (this.loginForm.invalid) {
        return;
      }
      const res: any = await this.authService.signinUser(this.loginForm.value);
      if (res.success) {
        this.authService.saveUserData(res.returnObject, this.loginForm.get('rememberMe').value ? true : false);
        if(this.type ==  this.userTypes.Admin)
        {
           this.router.navigateByUrl(this.authService.getAdminFirstLandPage());
        }
        else if(this.type ==  this.userTypes.Student)
        {
           this.router.navigateByUrl('/student/student-dashboard');
        }
      } else {
        console.log(res?.arabicMessage);
        this.helperService.alertError(res?.arabicMessage);
        this.isLoginFailed = true;
      }
    } catch (err) {
      this.isLoginFailed = true;
      this.helperService.errorMsg('حدث خطأ ما يرجى المحاولة مرة اخرى');
    }
  }

  async onSubmitSSO(NId ,UserType ) 
  {
    try {

      let body = 
      {
        NId: NId,
        UserType :UserType
      }
  
      const res: any = await this.authService.signinSSOUser(body);
      //console.log('ssssssss',res)
      if (res.success) {
        this.authService.saveUserData(res.returnObject , true );
        if(res.returnObject.type ==  +this.userTypes.Admin)
        {
           this.router.navigateByUrl(this.authService.getAdminFirstLandPage());
        }
        
        else if(res.returnObject.type==  +this.userTypes.Student)
        {
           this.router.navigateByUrl('/student/student-dashboard');
        }
      } else {
        console.log(res?.arabicMessage);
        this.helperService.alertError(res?.arabicMessage);
        this.isLoginFailed = true;
        this.authService.logout();
      }
    } catch (err) {
      this.isLoginFailed = true;
      this.helperService.errorMsg('حدث خطأ ما يرجى المحاولة مرة اخرى');
    }
  }
}
